import { render, staticRenderFns } from "./SAudioUploadEditor.vue?vue&type=template&id=31144550&"
import script from "./SAudioUploadEditor.vue?vue&type=script&lang=js&"
export * from "./SAudioUploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./SAudioUploadEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports